import { useState, useCallback, useEffect } from 'react';
import { useDeepEqualMemo } from '../../utils/hooks/useDeepEqualMemo';
/** Given an array of arrays of the form:
 *  const [value, resetter] = useTimedValue([
 *    [<some value A>, <some time A in ms>],
 *    [<some value B>, <some time B in ms>],
 *    ...
 *    [<some value N>, <some time N in ms>],
 *    // the last time value isn't needed
 *    [<some value Last>],
 *  ]);
 *
 *  this hook will return the value, wait that amount of time,
 *  then return the next value. It will repeat until all
 *  all times are used.
 *
 *  You can reset to the first again by calling the resetter
 *  function that's passed back.
 */
export var useTimedValue = function (unmemoizedValueAndTimeArray) {
    var valueAndTimeArray = useDeepEqualMemo(unmemoizedValueAndTimeArray || []);
    var _a = useState(0), valueAndTimeArrayIndex = _a[0], setValueAndTimeIndex = _a[1];
    var _b = valueAndTimeArray[valueAndTimeArrayIndex] || [], value = _b[0], time = _b[1];
    var hasAnother = valueAndTimeArrayIndex + 1 < valueAndTimeArray.length;
    useEffect(function () {
        if (!hasAnother || time === undefined) {
            return;
        }
        var timerId = setTimeout(function () {
            var nextIndex = valueAndTimeArrayIndex + 1;
            var nextValueAndTime = valueAndTimeArray[nextIndex];
            nextValueAndTime && setValueAndTimeIndex(nextIndex);
        }, time);
        return function () {
            clearTimeout(timerId);
        };
    }, [hasAnother, time, valueAndTimeArray, valueAndTimeArrayIndex]);
    var resetter = useCallback(function () { return setValueAndTimeIndex(0); }, []);
    return [value, resetter];
};
//# sourceMappingURL=useTimedValue.js.map